import { createContext, useContext } from 'react';
// these are only interfaces Which evaporate on transpilation.

// Any more hooks required to be used in the commons code can be added to this interface

const defaultDragMonitor = {
  canDrag: () => false,
  isDragging: () => false,
  getItem: () => null,
  getItemType: () => null,
  getDropResult: () => null,
  didDrop: () => false,
  getInitialClientOffset: () => null,
  getInitialSourceClientOffset: () => null,
  getClientOffset: () => null,
  getSourceClientOffset: () => null,
  getDifferenceFromInitialOffset: () => null,
  getTargetIds: () => [],
  receiveHandlerId: () => {},
  getHandlerId: () => null,
  subscribeToStateChange: () => () => {}
};
const defaultDropMonitor = {
  canDrop: () => false,
  isOver: () => false,
  getItem: () => null,
  getItemType: () => null,
  getDropResult: () => null,
  didDrop: () => false,
  getInitialClientOffset: () => null,
  getInitialSourceClientOffset: () => null,
  getClientOffset: () => null,
  getSourceClientOffset: () => null,
  getDifferenceFromInitialOffset: () => null,
  receiveHandlerId: () => {},
  getHandlerId: () => null,
  subscribeToStateChange: () => () => {}
};
const defaultDragLayerMonitor = {
  isDragging: () => false,
  getItem: () => null,
  getItemType: () => null,
  getInitialClientOffset: () => null,
  getInitialSourceClientOffset: () => null,
  getClientOffset: () => null,
  getSourceClientOffset: () => null,
  getDifferenceFromInitialOffset: () => null
};
export const DefaultReactDndConstructs = {
  useDrag: spec => [typeof spec === 'function' ? spec().collect?.(defaultDragMonitor) ?? {} : spec.collect?.(defaultDragMonitor) ?? {}, () => null, () => null],
  useDrop: spec => [typeof spec === 'function' ? spec().collect?.(defaultDropMonitor) ?? {} : spec.collect?.(defaultDropMonitor) ?? {}, () => null],
  useDragLayer: spec => spec(defaultDragLayerMonitor),
  getEmptyImage: () => new Image()
};
export const ReactDndCtxt = /*#__PURE__*/createContext(DefaultReactDndConstructs);
export function useReactDndConstructs() {
  return useContext(ReactDndCtxt);
}
//# sourceMappingURL=ReactDndContext.js.map